import { t, TranslationKey } from '@lib/translation';


// Error messages for LPR API
const LPR_ERRORS_TRANSLATION_KEY = {
  ASSIGNED_USER_IDS_NOT_SUPPORTED: 'alpr.errors.assignedUserIdsNotSupported' as TranslationKey,
  DEVICE_NAMES_NOT_SUPPORTED: 'alpr.errors.deviceNamesNotSupported' as TranslationKey,
  FAILED_TO_LOAD_FIELDS: 'alpr.errors.failedToLoadFields' as TranslationKey,
  FAILED_TO_LOAD_NEXT_PAGE: 'alpr.errors.failedToLoadNextPage' as TranslationKey,
  FAILED_TO_LOAD_READ: 'alpr.errors.failedToLoadRead' as TranslationKey,
  FAILED_TO_LOAD_SEARCH_RESULTS: 'alpr.errors.failedToLoadSearchResults' as TranslationKey,
  INVALID_COORDINATES: 'alpr.errors.invalidCoordinates' as TranslationKey,
  MULTIPLE_COLORS_NOT_SUPPORTED: 'alpr.errors.multipleColorsNotSupported' as TranslationKey,
  PLATE_REQUIRED: 'alpr.errors.plateRequired' as TranslationKey,
  PLATE_STATE_NOT_SUPPORTED: 'alpr.errors.plateStateNotSupported' as TranslationKey,
  VEHICLE_BODY_NOT_SUPPORTED: 'alpr.errors.vehicleBodyNotSupported' as TranslationKey,
  VEHICLE_COLOR_NOT_SUPPORTED: 'alpr.errors.vehicleColorNotSupported' as TranslationKey,
  VEHICLE_MAKE_NOT_SUPPORTED: 'alpr.errors.vehicleMakeNotSupported' as TranslationKey,
} as const;

export const LPR_ERRORS: typeof LPR_ERRORS_TRANSLATION_KEY & {
  INVALID_VEHICLE_MAKE: (make: string) => string;
  INVALID_VEHICLE_COLORS: (colors: string) => string;
  INVALID_VEHICLE_TYPE: (type: string) => string;
} = {
  ...LPR_ERRORS_TRANSLATION_KEY,

  INVALID_VEHICLE_MAKE: (make: string) =>
    t('alpr.errors.invalidVehicleMake' as TranslationKey, { make }),
  INVALID_VEHICLE_COLORS: (colors: string) =>
    t('alpr.errors.invalidVehicleColors' as TranslationKey, { colors }),
  INVALID_VEHICLE_TYPE: (type: string) =>
    t('alpr.errors.invalidVehicleType' as TranslationKey, { type }),
};

// Type definitions for error handling
export type LprErrorType = keyof typeof LPR_ERRORS;

export interface LprWarningEntry {
  type: LprErrorType;
  message: string;
}

// Mapping from error keys to user-friendly filter names
export const ERROR_TO_FILTER_NAME = {
  VEHICLE_COLOR_NOT_SUPPORTED: 'Color',
  VEHICLE_MAKE_NOT_SUPPORTED: 'Make',
  VEHICLE_BODY_NOT_SUPPORTED: 'Type',
  PLATE_REQUIRED: 'License Plate',
  PLATE_STATE_NOT_SUPPORTED: 'State',
  MULTIPLE_COLORS_NOT_SUPPORTED: 'Multiple Colors',
  INVALID_VEHICLE_MAKE: 'Make',
  INVALID_VEHICLE_COLORS: 'Color',
  INVALID_VEHICLE_TYPE: 'Type',
  ASSIGNED_USER_IDS_NOT_SUPPORTED: 'Assigned User',
  DEVICE_NAMES_NOT_SUPPORTED: 'Device Name',
} as const;
